import { render, staticRenderFns } from "./LicenseExpireDate.vue?vue&type=template&id=b2f416bc&"
import script from "./LicenseExpireDate.vue?vue&type=script&lang=ts&"
export * from "./LicenseExpireDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports